import React, { useCallback, useContext, useEffect } from 'react'
import { View } from 'oio-react'
import uiConstants from 'config/constants/ui'
import NoteListBlock from 'src/apps/Notebook/components/NoteListBlock'
import NotebookContext from 'src/libraries/contexts/Notebook'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import TOCContext from 'src/libraries/contexts/TOC'
import NavVertical from '~/components/MainMenu/NavVertical'
import ActionBlock from '../ActionBlock'

const TOCMenu = () => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const { tocIsOpen, setTocIsOpen } = useContext(TOCContext)
   const { currentNotebook, setCurrentNotebook } = useContext(NotebookContext)

   const toggleToc = useCallback((event) => {
      const tagName = event.target.tagName.toLowerCase()
      const isContentEditable = event.target.contentEditable === 'true'

      if (tagName === 'input' || tagName === 'textarea' || isContentEditable) {
         return
      }

      if (event.keyCode === 32) {
         setTocIsOpen(prevTocIsOpen => !prevTocIsOpen)
      }
   }, [])

   useEffect(() => {
      document.addEventListener('keydown', toggleToc, false)

      return () => {
         document.removeEventListener('keydown', toggleToc, false)
      }
   }, [])

   return (
      <View
         position="fixed"
         top="0px"
         left="0px"
         right="0px"
         bottom="0px"
         zIndex={uiConstants.zIndexes.toc}
         style={{ pointerEvents: tocIsOpen ? 'auto' : 'none' }}>
         <View
            onClick={() => setTocIsOpen(false)}
            role="button"
            tabIndex={0}
            position="absolute"
            top="0px"
            left="0px"
            right="0px"
            bottom="0px"
            backgroundColor="rgba(20,10,10,0.5)"
            transition="opacity 400ms"
            transform={tocIsOpen ? 'translate3d(0,0,0)' : 'translate3d(-100%,0,0)'}
            opacity={tocIsOpen ? '1' : '0'}
         />
         <View
            display="flex"
            position="fixed"
            top="0px"
            left="0px"
            bottom="0px"
            width={currentNotebook
               ? 'calc(270px + 400px)'
               : 'calc(270px)'
            }
            backgroundColor={theme.tmpMainMenuBackgroundColor}
            boxShadow={tocIsOpen && '0px 0px 30px rgba(0,0,0,0.1)'}
            opacity={tocIsOpen ? '1' : '0'}
            transition="400ms ease transform"
            transform={tocIsOpen
               ? 'translate3d(0,0,0)'
               : 'translate3d(-100%,0,0)'
            }>
            <View
               flex="0 0 auto"
               width="270px"
               height="100%">
               <View
                  flex="0 0 auto"
                  width="100%"
                  height="calc(100% - 160px)"
                  paddingLeft={theme.tmpSpacing}
                  paddingRight="15px"
                  scroll="on">
                  <View height="18vh" />
                  <NavVertical onAppButtonClick={() => setCurrentNotebook(null)} />
               </View>
               <View
                  display="flex"
                  alignItems="flex-end"
                  width="100%"
                  height="160px"
                  paddingRight="15px"
                  paddingLeft={theme.tmpSpacing}>
                  <ActionBlock />
               </View>
            </View>
            {currentNotebook?.slug && (
               <View
                  flex="0 0 auto"
                  width="400px"
                  height="100%"
                  borderLeft={`1px solid ${theme.tmpMainMenuBorderColor}`}>
                  <NoteListBlock notebookSlug={currentNotebook.slug} />
               </View>
            )}
         </View>
      </View>
   )
}

export default TOCMenu
